import { useDisclosure } from '@/hooks';
import './style.less';
import { useWorkorderDetailContext } from '../../../WorkorderDetailProvider';
import { Button, Tooltip } from 'antd';
import { Group } from '@/components/_common';
import { X } from 'react-feather';
import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import StatusTag from '@/components/_common/StatusTag';
import { useWorkOrderComplementChangeStatus } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.hooks';
import { truncateString } from '@/utils/functions/truncateString';
import StatusWorkOrderSelectModal from '@/components/Settings/Profiles/StatusWorkOrder/StatusWorkOrderSelectModal';
import { GPStatusColor } from '@/core/domain/visual-management/status/status.types';

export default function ComplementHeaderStatus() {
  const {
    complement: { data: complement },
    workorder: { data: workorder },
  } = useWorkorderDetailContext();
  const [modalSelectStatus, modalSelectStatusActions] = useDisclosure();

  const workOrderComplementChangeStatus = useWorkOrderComplementChangeStatus();

  const activityStatus = complement?.activityStatusModel;

  async function handleComplementStatus(statusId?: string | null) {
    if (workorder && complement) {
      await workOrderComplementChangeStatus.mutateAsync({
        workorderId: workorder.id,
        complementId: complement.id,
        statusId,
      });
    }
  }

  return (
    <>
      <Group gap={4}>
        {!!activityStatus ? (
          <>
            <Tooltip title={activityStatus.name || ''}>
              <StatusTag
                size="lg"
                color={GPStatusColor[activityStatus.color]}
                label={truncateString(activityStatus.name, 20)}
                onClick={modalSelectStatusActions.open}
              />
            </Tooltip>

            <Button
              icon={<AntdFeatherIcon icon={<X cursor="pointer" />} size={14} />}
              size="small"
              onClick={() => handleComplementStatus(null)}
            />
          </>
        ) : (
          <StatusTag
            color="default"
            size="lg"
            className="card-select-tag"
            label="Selecionar Status"
            onClick={modalSelectStatusActions.open}
          />
        )}
      </Group>

      <StatusWorkOrderSelectModal
        onCancel={modalSelectStatusActions.close}
        open={modalSelectStatus}
        onCallback={handleComplementStatus}
        confirmLoading={workOrderComplementChangeStatus.isLoading}
      />
    </>
  );
}
